/*-----------------------------*\
    JS -> COMPONENTS -> POPUP
\*-----------------------------*/

/*
    Opens a pop up window when clicked. Can
    be used to toggle a popup for social
    media share buttons for example.

    <a href="http://facebook.com" class="js-popup">
        Facebook
    </a>
*/

WW.popup = function($) {
    'use strict';

    $('body').on('click', '.js-popup', function(e) {
        e.preventDefault();
        openPopup(this.href);
    });

    const openPopup = (target) => {

        let width = 575,
            height = 400,
            config = [
                'width=' + width,
                'height=' + height,
                'left=' + (($(window).width() - width) / 2),
                'top=' + (($(window).height() - height) / 2)
            ];
        window.open(target, 'title', config.join(','));
    };
    return this;
};

// place the following in main.js: .popup($)

